export const abilityType = {
  // we
  wecode: 'wecode',
  // 轻应用
  h5: 'h5',
  // 机器人
  robot: "robot"
}